const login = {
  name: 'trainingEnrollQueryLogin',
  path: '',
  component: resolve => require(['../../../../../../pages/portal/sbs/training/enroll-query/login'], resolve)
}

export default login
